import React from 'react';
import { Box, MenuItem, Select, Chip, ListItemText, OutlinedInput } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

export const OutstandingDateFilterSelect = ({
	disabled,
	title = 'Outstanding days',
	outstandingDate,
	onChange,
}) => {
	const options = ['All', '0 - 7', '7 - 14', '15 - 30', '31 - 60', '61 - 90', '90+'];

	return (
		<Box>
			<Select
				fullWidth
				disabled={disabled}
				value={outstandingDate ?? 'All'}
				input={<OutlinedInput />}
				sx={{ minHeight: 35, display: 'flex', alignItems: 'center' }}
				renderValue={(selected) =>
					selected ? (
						<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
							<Chip key={`${title}-chip-${selected}`} label={selected} size='small' />
						</Box>
					) : (
						''
					)
				}
			>
				{options.map((option) => (
					<MenuItem
						key={`${title}-select-${option}`}
						value={option}
						onClick={(e) => {
							e.stopPropagation();
							if (outstandingDate === option) {
								onChange(null);
							} else {
								onChange(option);
							}
						}}
					>
						<ListItemText primary={option} />
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};
